module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "adCardPage",
    attrs: {
      "id": "adc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('h2', {
    staticClass: "adCardHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Books by Janet Dean")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardsubhead"
  }, [_vm._v("Love Inspired Historical")]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Courting Miss Adelaide")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Courting the Doctor’s Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Substitute Bride")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page02"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbc4fa2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/substitutebridethe_adc.vue
// module id = 60
// module chunks = 0